import React from 'react';
import withLazyLoad from 'utils/withLazyLoad';
import withPid from 'utils/withPid';
import Slider from 'components/Slider';

import Market from '../../components/Market';

import logo from '../../images/tradeup-logo.png';
import text0 from '../../images/0.png';
import './style.scss';

const TradeUP: React.FC = () => {
    return (
        <>
            <Slider className="banner tradeup-root">
                <div className="no-commissions">
                    <div className="site-main" data-animation="a-flyTopIn">
                        <img className="tradeup-logo" src={logo} alt="TradeUP" />
                        <div className="text">
                            <p>Trade U.S. stocks and ETFs with</p>
                            <h3>$0 commissions </h3>
                            <img className="text-0-img" src={text0} alt="$0" />
                        </div>
                    </div>
                </div>
                <div className="spot">
                    <div className="site-main" data-animation="a-flyTopIn">
                        <img className="tradeup-logo" src={logo} alt="TradeUP" />
                        <h3>Spot Market Trends</h3>
                        <p>Stay up-to-date with our free streaming market datas</p>
                    </div>
                </div>
                <div className="advantage">
                    <div className="site-main" data-animation="a-flyTopIn">
                        <img className="tradeup-logo" src={logo} alt="TradeUP" />
                        <div className="text">
                            <h3>
                                Let’s
                                <br />
                                TradeUP
                            </h3>
                            <div className="divider" />
                            <p>
                                <span>$0</span> commissions
                            </p>
                            <p>
                                <span>$0</span> account minimum
                            </p>
                            <p>
                                <span>$0</span> data fees
                            </p>
                        </div>
                    </div>
                </div>
            </Slider>
            <Market />
        </>
    );
};

export default withLazyLoad(withPid('brand')(TradeUP));
